import { Grid, Typography } from "@mui/material";
import React from "react";

export function SafariPage() {
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        height: "100vh",
        fontSize: "18px",
      }}
    >
      <Typography
        sx={{
          fontSize: "18px",
        }}
      >
        Welcome to the Sample Request Application!
      </Typography>
      <Typography
        sx={{
          fontSize: "18px",
        }}
      >
        The current browser is unsupported at the moment,
      </Typography>
      <Typography
        sx={{
          fontSize: "18px",
          mt: 4,
        }}
      >
        Kindly use Google Chrome or Microsoft Edge
      </Typography>
      <Typography
        sx={{
          fontSize: "18px",
          mt: 4,
        }}
      >
        If you're facing any issues with Logging Into the application kindly
        <br /> report the issue to <b>helpdesk@ekfc.ae</b> with the following
        information
        <Typography
          sx={{
            fontSize: "18px",
          }}
        >
          <b> Email:</b> helpdesk@ekfc.ae <br />
          <b> Subject:</b> Sample Request Application <br />
          <b> Content:</b> Facing issue with login
        </Typography>
      </Typography>
    </Grid>
  );
}
